var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.472,
    height: 32.115,
    viewBox: "0 0 32.472 32.115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#00cd99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.853 9.099H7.619L1 15.739l15.236 15.38 15.236-15.317z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.298 9.099h-8.119l-3.12 6.64 7.177 15.38 7.177-15.317zM1.511 15.725h29.45M16.236 1v3.681m8.8-1.645L21.97 5.611M7.437 3.036l3.066 2.575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco);
export default __webpack_public_path__ + "static/media/ico.8aab1f86377bd659613f2e72432e2113.svg";
export { ForwardRef as ReactComponent };